export const themeTokens = {
  color: {
    brand: {
      500: "#239FC6",
      700: "#296F85",
      50: "#DCEAEE",
    },
    success: {
      500: "#53BE77",
      700: "#588968",
      50: "#E5F5EB",
    },
    danger: {
      500: "#FF3D61",
      700: "#C14B60",
      50: "#FFE7EC",
    },
    warning: {
      500: "#F9A825",
      700: "#F57F17",
      50: "#FFEB3B",
    },
    info: {
      500: "#239FC6",
    },
    text: {
      primary: "#1A1A2E",
      secondary: "#303030",
      inversePrimary: "#F5F7FB",
      inverseSecondary: "#E6EBF2",
    },
    surface: {
      page: "#F4F4F4",
      subtle: "#F9F9F9",
      highlight: "#DDDDDD",
      card: "#FFFFFF",
      darkPage: "#111827",
      darkSubtle: "#1B2535",
      darkHighlight: "#253248",
      darkCard: "#1B2535",
    },
    common: {
      white: "#FFFFFF",
      black: "#000000",
    },
  },
  font: {
    familyBase: "Poppins, \"Helvetica\", \"Arial\", sans-serif",
    sizeBase: 16,
    weightRegular: 400,
    weightMedium: 500,
    weightSemibold: 600,
    weightBold: 700,
  },
  radius: {
    sm: 4,
    md: 8,
    lg: 12,
    pill: 20,
  },
  spacing: {
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    8: 32,
    10: 40,
    12: 48,
  },
};
